import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
// @material-ui/lab components
// @material-ui/icons components

// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import CardLightTableTables from "components/Cards/Tables/ViewBatchForStudentPassive.js";

import componentStyles from "assets/theme/views/admin/tables.js";

const useStyles = makeStyles(componentStyles);

const Tables = () => {
  const classes = useStyles();
  return (
    <>
      <SimpleHeader section="Enrolled Courses" subsection="Passive" />
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <CardLightTableTables />
       
      </Container>
    </>
  );
};

export default Tables;
